// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.OPEN_YOUNG_TUTOR_TYPE_RESET,
});

const validateStep = () => ({
    type: actionTypes.OPEN_YOUNG_TUTOR_TYPE_VALIDATE_STEP,
});


const set = (value) => ({
    type: actionTypes.OPEN_YOUNG_TUTOR_TYPE_SET,
    payload: {
        value
    }
});


module.exports = {
    reset,
    set,
    validateStep,
};
